<div class="content">
  <h5>Recommended for You</h5>
  <app-product-list [products]="products"></app-product-list>
</div>
